// Func = limiting Scope for this file
var lastScrollTop = 0;
//booking dates
var start = document.getElementById('arriveInput').value;
var end = document.getElementById('departureInput').value;
var opened = 0 ;


(function(){

	$(document).ready(function () {

		//Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		$('p').each(function() {
			var $this = $(this);
			if($this.html().replace(/\s| /g, '').length == 0){
			  $this.remove();
			}
		});


		$('.slider-sym-slides').slick({
			arrows: true, 
			fade: false, 
			accessibility: true,
			variableWidth: true, 
			slidesToShow: 1, 
			centerMode: true, 
			initialSlide: 2, 
			infinite: true
		});

		$( ".menu-burger" ).click(function() {
			if ($("#header").hasClass("open-menu")) {
				$("#header").removeClass("open-menu");
				$("#header").addClass("close-menu");
			}
			else{
				$("#header").addClass("open-menu");
				$("#header").removeClass("close-menu");

			}
		});


		$('#audio-control').click(function(){
			if( $("#video").prop('muted') ) {
				  $("#video").prop('muted', false);
				  $(this).removeClass("audio-off");
			
			  // or toggle class, style it with a volume icon sprite, change background-position
			} else {
			  $("#video").prop('muted', true);
			  $(this).addClass("audio-off");
		
			}
		});

		

		$( ".booking__close" ).click(function() {

			if ($(".booking__container").hasClass("open-booking-container")) {
				$(".booking__container").removeClass("open-booking-container");
				$(".booking__container").addClass("close-booking-container");
			}
			else{
				$(".booking__container").addClass("open-booking-container");
				$(".booking__container").removeClass("close-booking-container");

			}
			if ($("#header").hasClass("open-booking")) {
				$("#header").removeClass("open-booking");
				$("#header").addClass("close-booking");
			}
			else{
				$("#header").addClass("open-booking");
				$("#header").removeClass("close-booking");

			}
			
			
		});
		$( "#booking-trigger" ).click(function() {
	
			if ($(".booking__container").hasClass("open-booking-container")) {
				$(".booking__container").removeClass("open-booking-container");
				$(".booking__container").addClass("close-booking-container");
			}
			else{
				$(".booking__container").addClass("open-booking-container");
				$(".booking__container").removeClass("close-booking-container");

			}
			if ($("#header").hasClass("open-booking")) {
				$("#header").removeClass("open-booking");
				$("#header").addClass("close-booking");
			}
			else{
				$("#header").addClass("open-booking");
				$("#header").removeClass("close-booking");

			}
			
			
		});

		$( ".booking__close-1" ).click(function() {

			if ($(".booking__container-1").hasClass("open-booking-container")) {
				$(".booking__container-1").removeClass("open-booking-container");
				$(".booking__container-1").addClass("close-booking-container");
			}
			else{
				$(".booking__container-1").addClass("open-booking-container");
				$(".booking__container-1").removeClass("close-booking-container");

			}
			if ($("#header").hasClass("open-booking")) {
				$("#header").removeClass("open-booking");
				$("#header").addClass("close-booking");
			}
			else{
				$("#header").addClass("open-booking");
				$("#header").removeClass("close-booking");

			}
			
			
		});

		$( "#booking-trigger-1" ).click(function() {
	
			if ($(".booking__container-1").hasClass("open-booking-container")) {
				$(".booking__container-1").removeClass("open-booking-container");
				$(".booking__container-1").addClass("close-booking-container");
			}
			else{
				$(".booking__container-1").addClass("open-booking-container");
				$(".booking__container-1").removeClass("close-booking-container");

			}
			if ($("#header").hasClass("open-booking")) {
				$("#header").removeClass("open-booking");
				$("#header").addClass("close-booking");
			}
			else{
				$("#header").addClass("open-booking");
				$("#header").removeClass("close-booking");

			}
			
			
		});

		if ($(".privary-navigation__item a").hasClass("active")) {
			var bg = $(".privary-navigation__item a.active").text();
			$('.menu__container-inner').css("background-image", "url(/assets/images/menus-" + bg.toLowerCase() + ".jpg)");
		  }


		//Change background image menu with hover
		$('.privary-navigation__item a').hover(function() { 
			$( ".privary-navigation__item a" )
				.mouseout(function() {
					// if ($(".privary-navigation__item a").hasClass("active")) {
					// 	var bg = $(".privary-navigation__item a.active").text();
					// 	$('.menu__container-inner').css("background-image", "url(/assets/images/menus-" + bg.toLowerCase() + ".jpg)");
					//   }
				})
				.mouseover(function() { 
					if ($(".privary-navigation__item").hasClass("changeBg")) {
						var bg = $(".privary-navigation__item.changeBg a").text();
						$('.menu__container-inner').css("background-image", "url(/assets/images/menus-" + bg.toLowerCase() + ".jpg)");
					}
				});
		});


	


			//map interactive
			
				
		

		

		//map interactive
		// $('.text--container').each(function (i) {
		// 	$( "a.hotspot--item-"+i )
		// 	.mouseout(function() {
		// 		$( ".hotspot--text-"+i).removeClass("hover");
		// 	})
		// 	.mouseover(function() {
		// 		$( ".hotspot--text-"+i).addClass("hover");
		// 	});
		// });

		

		// $( "a.hotspot--item-0" ).click(function() {
		// 	if ($(".hotspot--text-0").hasClass("hover")) {
		// 		$( ".hotspot--text-0").removeClass("hover");
		// 	}
		// 	else{
		// 		$( ".hotspot--text-0").addClass("hover");
		// 	}
		//   });
	

		// $('a.hotspot--item-1').hover(function() { 
		// 	$(".hotspot--text-1").addClass("hover");	  
		// });

			


		


		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("changeBg").fadeIn(200);
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("changeBg");
			$('ul.submenu',this).fadeOut(200);
		});

	

	 /**
     * Check in and check out datepicker for booking engine
     ******************************************/
    var after_first_date_selection = false;

	$( "#CheckIn" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
        dateFormat: "M d yy",
        altField: "#CheckIn--alt",
        altFormat: "mm-dd-yy",
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function( selectedDate ) {
			var getDate = $(this).datepicker('getDate');
        	var newDate = new Date(getDate.getTime());
        	newDate.setDate(newDate.getDate() + 1);
			$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			if(after_first_date_selection){
			    console.log("selection!");
                $( "#CheckOut" ).datepicker( "setDate", newDate );
            }
        }
	});
	$( "#CheckOut" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
        dateFormat: "M d yy",
        altField: "#CheckOut--alt",
		altFormat: "mm-dd-yy",
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function( selectedDate ) {
			// $( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
            return after_first_date_selection = true;
		}
	});
	
	// Map: Return to previous page button. Change body id to match map template's name.
	//$('body#map-category #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">Back to previous page</a>');

	//Add mising Placeholder
	$("form .field, form .form-entry").each(function(){
		var label__val = $(this).find("label").text();
		$(this).find("input, textarea").prop("placeholder", label__val);
	});


    //booking datepicker for [ header booking ]
		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		setUpBooking();
   
        $('#altDates').on('change', function(){
            let dates = $(this).val().split('/');
            $('#arriveInput').attr('value',dates[0]);
            $('#departureInput').attr('value',dates[1]);
            start = dates[0];
            end = dates[1];

            $('#calendarContainer').datepicker( 'destroy' );
            setUpBooking();
            $('#calendarContainer').datepicker("setDate", start);
        })
        $('#bookingCta').click(function(){
            $('#bookingContainer').addClass('active')
        })
        $('#bookingClose').click(function(){
            $('#bookingContainer').removeClass('active')
        })

		

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		

		function setUpBooking() {
	

			$('#calendarContainer').datepicker({
				changeMonth: false,
				minDate:0,
				dateFormat: 'mm-dd-yy',
				numberOfMonths: 2,
				beforeShowDay: function (date) {

					setTimeout(function() {
						document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
							e.setAttribute('tabindex', '-1');
						})
					}, 1000);
					
					$.datepicker._defaults.dateFormat = "mm-dd-yy";
					var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
					var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
					if (date.getTime() == startDate.getTime()) {
						return [true, "startday"];
					} else {
						if (date.getTime() == endDate.getTime()) {
							return [true, "endday"];
						} else {
							if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
								return [true, "days"];
							} else {
								return [true, ""];
							}
						}
					}
				},
				onSelect: function (date) {
					var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
					var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
					var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);
		
					if (opened == 0) {
						opened = 1;
						start = date;
						end = date;
						//opencheck = 0;
					} else {
						opened = 0;
						if (selectedDate <= arrive) {
							end = start;
							start = date;
						} else {
							end = date;
						}
					}
		
					$('#arriveInput').attr('value',start);
					$('#departureInput').attr('value',end);
					$('#altDates').attr('value',start +'/'+end);
				
				}
			});
		}

	//Update HTML
	$(".footer").html(function(buscayreemplaza, reemplaza) {
		return reemplaza.replace('<nav id="secondary-nav" class="secondary-navigation" role="navigation" aria-label="Secondary">', '<nav id="secondary-nav-footer" class="secondary-navigation" role="navigation" aria-label="Secondary-nav-footer">');
	});
	$(".footer").html(function(buscayreemplaza, reemplaza) {
		return reemplaza.replace('<ul id="secondary-navigation" class="secondary-navigation__list">', '<ul id="secondary-navigation-footer" class="secondary-navigation__list">');
	});

	function addAltAttrs() {
		//get the images
		let images = document.querySelectorAll(".squarelovin-widget-container img"); 
		
		console.log(images);
		//loop through all images
		for (let i = 0; i < images.length; i++) {
			images[i].setAttribute("alt", "Oceans Edge Key West Resort & Marina img-" + [i]); 
	
		}
	
	}
	setTimeout(function(){
		addAltAttrs();
	}, 5000);

	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}